<template>
    <article id="hof-compare-2018" class="post">
        <post-header v-bind:post="post"></post-header>

        <compare-table v-bind:data="data" v-bind:cols="cols"></compare-table>

        <div class="body-text">
            <h4 class="text-heading">Title?</h4>
            <p>
                Text
            </p>  
        </div>
    </article>
</template>

<script>
import PostHeader from '../../post-sections/post-header.vue';
import CompareTable from './compare-table.vue';

export default {
    name: 'hof-compare-2018',
    props: ['post'],
    components: {
        'post-header': PostHeader,
        'compare-table': CompareTable
    },
    data() {
        let data = require('./data/data.json');
        clean(data);

        return {
            data: data,
            cols: ['PA', 'R', 'H', 'HR', 'RBI', 'SB', 'AVG', 'OBP', 'SLG', 'OPS', 'OPS+']
        };
    }
};

function clean(data) {
    let toFixed = (v, digits) => (+v).toFixed(digits);
    let trim = v => (v.substr(0, 1) === '0' ? v.substr(1) : v);

    let formats = {
        Name: v => v,
        Years: v => toFixed(v, 0),
        WAR: v => toFixed(v, 1),
        PA: v => toFixed(v, 0),
        R: v => toFixed(v, 0),
        H: v => toFixed(v, 0),
        HR: v => toFixed(v, 0),
        RBI: v => toFixed(v, 0),
        SB: v => toFixed(v, 0),
        AVG: v => trim(toFixed(v, 3)),
        OBP: v => trim(toFixed(v, 3)),
        SLG: v => trim(toFixed(v, 3)),
        OPS: v => trim(toFixed(v, 3)),
        'OPS+': v => toFixed(v, 0),
        W: v => toFixed(v, 0),
        ERA: v => toFixed(v, 2),
        'ERA+': v => toFixed(v, 0),
        WHIP: v => toFixed(v, 3),
        G: v => toFixed(v, 0),
        GS: v => toFixed(v, 0),
        SV: v => toFixed(v, 0),
        IP: v => toFixed(v, 1),
        SO: v => toFixed(v, 0),
        'Cy Youngs': v => toFixed(v, 0),
        'Cy Young Shares': v => toFixed(v, 2),
        MVPs: v => toFixed(v, 0),
        'MVP Shares': v => toFixed(v, 2),
        Pos: v => v
    };

    data.forEach(d => {
        Object.keys(d).forEach(c => {
            d[c] = formats[c](d[c]);
        });
    });
}
</script>

<style>
</style>
